import { render, staticRenderFns } from "./ForwardedOrderComponent.vue?vue&type=template&id=0ed42918"
import script from "./ForwardedOrderComponent.vue?vue&type=script&lang=js"
export * from "./ForwardedOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports